import type { HttpClient } from '@/api/httpClient';
import type { AdminPage, SensitiveActionInput } from '@/admin/adminApi';

export const SYNC_SUPERVISION_PATH = '/operations/synchronizations';
export interface SyncAttempt {
  readonly id: string;
  readonly userId: string;
  readonly email: string | null;
  readonly deviceHash: string | null;
  readonly direction: 'push' | 'pull';
  readonly status: 'accepted' | 'conflict' | 'rejected' | 'technical_error';
  readonly reason: string;
  readonly occurredAt: string;
}
export interface SyncRecoveryRequest {
  readonly id: string;
  readonly attemptId: string;
  readonly userId: string;
  readonly deviceHash: string;
  readonly action: 'retry' | 'resync';
  readonly status: 'pending' | 'running' | 'completed' | 'failed' | 'expired';
  readonly createdAt: string;
  readonly expiresAt: string;
  readonly resultCode: string | null;
}

export const createSyncSupervisionApi = (http: HttpClient) => ({
  attempts: (page: number, status: string, userId: string): Promise<AdminPage<SyncAttempt>> =>
    http.request({ path: '/admin/synchronizations', query: { page, perPage: 25, status, userId } }),
  requests: (page: number, userId: string): Promise<AdminPage<SyncRecoveryRequest>> =>
    http.request({ path: '/admin/synchronizations/requests', query: { page, perPage: 25, userId } }),
  recover: (
    attemptId: string,
    action: 'retry' | 'resync',
    idempotencyKey: string,
    input: SensitiveActionInput,
  ): Promise<SyncRecoveryRequest> =>
    http.request({
      path: `/admin/synchronizations/${encodeURIComponent(attemptId)}/recover`,
      method: 'POST',
      body: { action, idempotencyKey, ...input },
    }),
});
